import * as React from 'react';
import { forwardRef, useState } from 'react'
import {
    AppBar, UserMenu, Layout,
    useLogout, useAuthProvider
} from 'react-admin';
import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import { ReactQueryDevtools } from 'react-query/devtools';

// It's important to pass the ref to allow MUI to manage the keyboard navigation
const AccountMenu = forwardRef((props, ref) => {
    const { userId, userName, ...nextProps } = props;
    return (
        userId !== null ?
            <MenuItem ref={ref} component={Link} {...nextProps} to={`/users/${userId}`}>
                <ListItemIcon>
                    <AccountIcon />
                </ListItemIcon>
                <ListItemText>
                    {userName}
                </ListItemText>
            </MenuItem>
            :
            <MenuItem ref={ref} component={Link} {...nextProps} to={`/login?create`} >
                <ListItemIcon>
                    <AccountIcon />
                </ListItemIcon>
                <ListItemText>
                    Create account
                </ListItemText>
            </MenuItem>
    );
});

const LoginOrOutMenu = forwardRef((props, ref) => {
    // eslint-disable-next-line no-unused-vars
    const { userId, userName, ...nextProps } = props;
    const logout = useLogout();
    const handleLogoutClick = () => logout()
    return (
        userId !== null ?
            <MenuItem onClick={handleLogoutClick} ref={ref}>
                <ListItemIcon>
                    <LogoutIcon />
                </ListItemIcon>
                <ListItemText>
                    Logout
                </ListItemText>
            </MenuItem>
            :
            <MenuItem ref={ref} component={Link} {...nextProps} to="/login">
                <ListItemIcon>
                    <LoginIcon />
                </ListItemIcon>
                <ListItemText>
                    Login
                </ListItemText>
            </MenuItem>
    )
});

const MyUserMenu = props => {
    const authProvider = useAuthProvider();
    const [userId, setUserId] = useState(undefined)
    const [userName, setUserName] = useState(undefined)
    authProvider.getIdentity().then((identity) => {
        setUserId(identity.id);
        setUserName(identity.name);
    }).catch(() => {
        setUserId(null);
        setUserName(null);
    })
    return (
        userId === undefined ? null :
        <UserMenu {...props}>
            <AccountMenu userId={userId} userName={userName}/>
            <LoginOrOutMenu userId={userId} userName={userName}/>
        </UserMenu >
    );
}
const MyAppBar = props => <AppBar {...props} userMenu={<MyUserMenu />} />;
// const MyAppBar = props => <AppBar {...props} userMenu={null} />;
const MyLayout = props => (
    <>
        <Layout {...props} appBar={MyAppBar} />
        <ReactQueryDevtools initialIsOpen={true} />
    </>
)

export default MyLayout